import * as Styled from './styled'
import { GradientSvg } from './GradientSvg'

const sizeData = {
  small: {
    wrapperSize: 40,
    textType: 'h5'
  },
  large: {
    wrapperSize: 68,
    textType: 'subtitle'
  }
} as const

type TSizeType = keyof typeof sizeData

interface ILoadingGradientProps {
  progress?: number | null
  size?: TSizeType
  position?: 'absolute' | 'relative'
}

export const LoadingGradient = ({
  progress,
  size = 'large',
  position = 'relative'
}: ILoadingGradientProps) => {
  const { wrapperSize, textType } = sizeData[size]
  return (
    <Styled.LoadingGradientWrapper $size={wrapperSize} $position={position}>
      <GradientSvg className="gradient" />
      <Styled.LoadingGradientOverlay>
        {progress !== null && (
          <Styled.LoadingGradientText
            type={textType}
            color="secondarySemiDark"
            fontWeight="600"
          >
            {progress}%
          </Styled.LoadingGradientText>
        )}
      </Styled.LoadingGradientOverlay>
    </Styled.LoadingGradientWrapper>
  )
}
